// @flow

import { get, partial } from 'lodash';

import isServiceHidden from './isServiceHidden';
import type { Service } from '@zapier/services/src/types';

const isPathTrue = (path, service) => Boolean(get(service, path, null));
const isAnyPathTrue = (paths, service) =>
  paths.some(path => isPathTrue(path, service));

// The multiple keys here represent legacy data structure and the updated
// GraphQL equivalent
export const isBeta = partial(isAnyPathTrue, ['beta', 'isBeta']);
export const isBuiltIn = (service: Service) =>
  service.isBuiltIn || get(service, 'builtIn');
export const isDeprecated = partial(isAnyPathTrue, [
  'deprecated',
  'isDeprecated',
]);
export const isFeatured = (service: Service) =>
  service.isFeatured || get(service, 'featured');
export const isHidden = isServiceHidden;
export const isPremium = partial(isAnyPathTrue, ['premium', 'isPremium']);
export const isInvite = (service: Service) =>
  service.isInvite || get(service, 'invitepp');
export const isPublic = (service: Service) =>
  service.isPublic || get(service, 'public');
export const isOauth = (service: Service) => {
  const authType = get(service, 'authType', null);
  const oauthService = get(service, ['meta', 'oauth'], false);
  return authType === 'oauth' || oauthService;
};
